import { DEFAULT_ROUTES_BY_ROLE } from '@auth/consts/default-routes-by-role.const';
import { Role } from '@auth/enums/role.enum';
import { Url } from '@core/enums/url.enum';
import { AppRoutes } from '@core/interfaces/app-routes.interface';
import { lastUrlSegment } from '@core/utils/last-url-segment.util';

export const CONTRACTOR_ROUTES: AppRoutes = [
  {
    path: lastUrlSegment(Url.ContractorManageEmployees),
    children: [
      {
        path: lastUrlSegment(Url.ContractorEmployeeProfiles),
        loadComponent: () =>
          import(
            '@features/manage-employees/pages/contractor-employee-profiles-page/contractor-employee-profiles-page.component'
          ).then((m) => m.ContractorEmployeeProfilesPageComponent),
      },
      {
        path: lastUrlSegment(Url.ContractorCopyEmployees),
        loadComponent: () =>
          import(
            '@features/manage-employees/pages/contractor-copy-employees-page/contractor-copy-employees-page.component'
          ).then((m) => m.ContractorCopyEmployeesPageComponent),
      },
      {
        path: lastUrlSegment(Url.ContractorMergeEmployees),
        loadComponent: () =>
          import(
            '@features/manage-employees/pages/contractor-merge-employees-page/contractor-merge-employees-page.component'
          ).then((m) => m.ContractorMergeEmployeesPageComponent),
      },
      {
        path: '**',
        redirectTo: Url.ContractorEmployeeProfiles,
      },
    ],
  },
  {
    path: lastUrlSegment(Url.ContractorEmployeeSettings),
    children: [
      {
        path: lastUrlSegment(Url.ContractorFringeBenefitsSetup),
        loadComponent: () =>
          import(
            '@features/employee-settings/pages/contractor-fringe-benefits-setup-page/contractor-fringe-benefits-setup-page.component'
          ).then((m) => m.ContractorFringeBenefitsSetupPageComponent),
      },
      {
        path: lastUrlSegment(Url.ContractorOtherDeductionsMatchSetup),
        loadComponent: () =>
          import(
            '@features/employee-settings/pages/contractor-other-deductions-match-setup-page/contractor-other-deductions-match-setup-page.component'
          ).then((m) => m.ContractorOtherDeductionsMatchSetupPageComponent),
      },
      {
        path: '**',
        redirectTo: Url.ContractorFringeBenefitsSetup,
      },
    ],
  },
  {
    path: '**',
    redirectTo: DEFAULT_ROUTES_BY_ROLE[Role.FullContractor],
  },
];
